import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LinkHelper } from 'pac-platform-ui-auth';
import { CloudBar } from 'pac-ux-components';

const linkHelper = new LinkHelper();

let portalAppUrls = {
    prd: 'https://portal.nextcloud.aero',
    test: 'https://portal.nextcloud.aero',
    dev: 'https://portal.nextcloud.aero'
};

let stage = typeof process.env.REACT_APP_STAGE !== 'undefined' ? process.env.REACT_APP_STAGE : 'prd';

let cloudHomeUrl = portalAppUrls[stage];

let profileUrl = [portalAppUrls[stage], 'app/profile'].join('/');

let notificationsUrl = [portalAppUrls[stage], 'app/notifications'].join('/');

let settingsUrl = [portalAppUrls[stage], 'app/settings'].join('/');

const PlatformCloudbar = ({ cloudHomeUrl, profileUrl, notificationsUrl, settingsUrl }) => {
    const [userSession, setUserSession] = useState({
        idToken: { jwtToken: '' }
    });

    const [user, setUser] = useState({
        attributes: { username: '', given_name: '', family_name: '' }
    });

    const [applications, setApplications] = useState([]);

    let urlTokenFragment = linkHelper.getTokenFragment(userSession);

    let cloudBarUser = {
        name: [user.attributes.given_name, user.attributes.family_name].join(' '),
        profileUrl: profileUrl,
        notificationsUrl: notificationsUrl,
        settingsUrl: settingsUrl
    };

    return (
        <CloudbarComponent
            cloudHomeUrl={cloudHomeUrl}
            user={cloudBarUser}
            applications={applications}
            urlTokenFragment={urlTokenFragment}
        />
    );
};

export default PlatformCloudbar;

PlatformCloudbar.propTypes = {
    cloudHomeUrl: PropTypes.string,
    profileUrl: PropTypes.string,
    notificationsUrl: PropTypes.string,
    settingsUrl: PropTypes.string
};

PlatformCloudbar.defaultProps = {
    cloudHomeUrl: cloudHomeUrl,
    profileUrl: profileUrl,
    notificationsUrl: notificationsUrl,
    settingsUrl: settingsUrl
};

export const CloudbarComponent = ({ cloudHomeUrl, user, applications, urlTokenFragment }) => {
    let prodApplications = filterTools(applications, 'prod');

    let lastUsedTools = prodApplications.map((app) => {
        return {
            name: app.name,
            icon: getResizedImageUrl(app),
            path: app['app-link'] + urlTokenFragment
        };
    });

    let devApplications = filterTools(applications, 'dev');

    let otherTools = devApplications.map((app) => {
        return {
            name: app.name,
            icon: getResizedImageUrl(app),
            path: app['app-link'] + urlTokenFragment
        };
    });

    return (
        <CloudBar
            cloudHomeUrl={cloudHomeUrl}
            user={user}
            notificationCount={0}
            lastUsedTools={lastUsedTools}
            otherTools={otherTools}
        />
    );
};

const filterTools = (allApplications, appType) => {
    let applications = allApplications.filter((item) => item['app-type'] === appType);
    return applications.slice(0, 3);
};

const getResizedImageUrl = (app) => {
    const logoUrl = app['logo-url'];
    const extension = logoUrl.substr(-3);

    if (extension === 'svg') {
        return logoUrl;
    }

    let request = {
        bucket: 'pac-platform-images-us-west-2',
        key: logoUrl,
        edits: {
            resize: {
                width: 45,
                height: 45,
                fit: 'cover'
            }
        }
    };

    const str = JSON.stringify(request);
    const encoded = window.btoa(str);

    return ['https://d2g0vtxljsrm9e.cloudfront.net', encoded].join('/');
};

CloudbarComponent.propTypes = {
    cloudHomeUrl: PropTypes.string,
    user: PropTypes.shape({
        attributes: PropTypes.shape({
            username: PropTypes.string.isRequired,
            given_name: PropTypes.string.isRequired,
            family_name: PropTypes.string.isRequired
        })
    }),
    applications: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            'app-type': PropTypes.string,
            'app-link': PropTypes.string,
            'logo-url': PropTypes.string
        })
    ).isRequired,
    urlTokenFragment: PropTypes.string
};
